export { default as Dashboard } from './component';
